// (function () {
//     'use strict';

//     angular.module("imApp").factory("p2WebpageLinkEditService", ['$ihttp', function ($ihttp) {
//         let service = {
//             getEdit: function (parms) {
//                 return $ihttp.post({
//                     method: 17,
//                     parameters: parms || {}
//                 });
//             },
//             saveObj: function (edit) {
//                 return $ihttp.post({
//                     method: 18,
//                     parameters: edit
//                 });
//             }
//         };

//         return service;
//     }]);
// })();
